const Videostream = () => {
  return (
    <iframe
      width="1400"
      height="600"
      src="https://www.youtube.com/embed/Mvw-fL7LdJY?si=v7vfHqiTcjYD-w-H"
      title="YouTube video player"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    ></iframe>
  );
};

export default Videostream;
